interface PostJsonParams {
  body: Record<string, unknown>;
  path: string;
  signal?: AbortSignal;
}

export async function postJson<T>({
  body,
  path,
  signal,
}: PostJsonParams): Promise<T> {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}/digital/service/api${path}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
      signal,
    }
  );

  if (!response.ok) {
    throw new Error(
      `Serviceability request failed: ${response.status} ${response.statusText}`
    );
  }

  return response.json() as Promise<T>;
}
